<template>
  <q-page>
    <h2 class="text-center">Add Stock</h2>
    <q-btn class="q-ma-md" @click="downloadExample">Download Example CSV</q-btn>
    <q-table
      :data="validateStockToAdd"
      :columns="columns"
      separator="none"
      dense
      :loading="$apollo.loading"
      :filter="filter"
      :pagination.sync="pagination"
      :rows-per-page-options="[10, 20, 50]"
      binary-state-sort
      row-key="name" >
      <template v-slot:top>
        <q-space />
        <q-input dense debounce="300" color="primary" v-model="filter">
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>
      <template v-slot:body-cell-is_ok="props">
        <td :props="props" class="text-center">
          <q-icon name="check" color="green" v-if="props.row.allValid" />
          <q-icon name="close" color="red" v-else />
        </td>
      </template>

      <template v-slot:body-cell-reference="props">
        <q-td :props="props">
          <router-link v-if="props.row.product" :to="`/admin/products/${props.row.product.id||''}`">{{props.value}}</router-link>
          <span v-else>{{props.value}}</span>
        </q-td>
      </template>

      <template v-slot:body-cell-matched_product="props">
        <td :props="props" class="text-center">
          <q-icon name="check" color="green" v-if="props.value">
<!--            <q-tooltip>{{props.row.matched_product.attributes.Brand}} {{props.row.matched_product.name}}</q-tooltip>-->
          </q-icon>
          <q-icon name="close" color="red" v-else />
        </td>
      </template>
      <template v-slot:body-cell-matched_sku="props">
        <td :props="props" class="text-center">
          <q-icon name="check" color="green" v-if="props.value">
            <q-tooltip>Stock: {{props.row.sku.stock}}</q-tooltip>
          </q-icon>
          <span v-else>
            <q-tooltip>You'll need to create this sku first.</q-tooltip>
            <q-icon name="close" color="red" style="cursor: pointer;"/>
<!--            <q-tooltip>Click to create the sku</q-tooltip>-->
<!--            <q-icon name="close" color="red" @click="createSku(props.row)" style="cursor: pointer;"/>-->
          </span>
        </td>
      </template>
      <template v-slot:body-cell-matched_colour="props">
        <td :props="props" class="text-center">
          <span v-if="props.value">
            <div :style="{border: '1px silver solid', backgroundColor: props.value.hex, width: '10px',height: '10px'}" class="inline-block"></div>
            {{props.value.group}} - {{props.value.name}}
          </span>
          <q-icon name="close" color="red" v-else />
        </td>
      </template>
      <template v-slot:no-data="{ icon, message, filter }">
        <div class="full-width row flex-center text-accent q-gutter-sm">
          <q-uploader
            :factory="uploaderFactoryColours"
            label="Colours (upload first, optional)"
            :max-file-size="10000000"
            accept=".csv"
            auto-upload
            hide-upload-btn
            :disabled="$apollo.loading"
            style="max-width: 300px"
          />
          <q-uploader
            :factory="uploaderFactory"
            label="Stock To Add"
            :max-file-size="10000000"
            accept=".csv"
            auto-upload
            hide-upload-btn
            :disabled="$apollo.loading"
            style="max-width: 300px"
          />
        </div>
      </template>
    </q-table>
    <q-btn class="q-ma-md" v-if="validateStockToAdd.length" @click="$apollo.queries.validateStockToAdd.refetch()">Re-validate</q-btn>
    <q-btn class="q-ma-md" @click="clearAll">Clear All</q-btn>
    <span>
      <q-tooltip v-if="!allRowsOk">Cant upload until all errors above ar resolved.  You will need to modify the csv and re-upload.</q-tooltip>
      <q-btn class="q-ma-md" @click="addAll" :disabled="!csvData.length || !allRowsOk">
        Add All Stock
      </q-btn>
    </span>
    <pre>
      {{result}}
    </pre>
  </q-page>
</template>

<script>
import moment from 'moment'
import gql from 'graphql-tag'
import { csv } from 'csvtojson'
import saveAs from 'file-saver'
import adminNotifyError from '../../util/adminNotifyError'

export default {
  name: 'PageAdminAddStock',
  apollo: {
    validateStockToAdd () {
      return {
        query: gql`query validateStockToAdd ($input: [AddStockInput!]!) {
            validateStockToAdd (input: $input) {
                brand
                reference
                colour
                qtyToAdd
                allValid
                sku {
                  id
                  stock
                  options
                }
                product {
                  id
                  name
                }
                fullColour
            }
        }`,
        variables () {
          return {
            input: this.stockInput
          }
        },
        fetchPolicy: 'network-only'
        // async result (result) {
        //   // Clear all warnings
        //   if (result.data.validateCart === true) this.addStockErrors = []
        // },
        // error (error) {
        //   // Error is stored in a rather confusing structure.  See if future apollo updates break this... :(
        //   const parentCartValidationError = error.graphQLErrors?.find(v => v.extensions?.exception?.name === 'AddStockValidationErrors')?.extensions?.exception || {}
        //   this.addStockErrors = parentCartValidationError?.errors || []
        //   console.log(this.addStockErrors)
        // }
      }
    }
    // products () {
    //   return {
    //     query: gql`
    //       query products ($filter: ProductFilterInput) {
    //         products(filter: $filter, store: AllProducts) {
    //           products {
    //             id,
    //             name,
    //             reference,
    //             attributes,
    //             images {
    //               url
    //               name
    //             },
    //             urlSlug,
    //             description,
    //             skus {
    //               id,
    //               showInContainer,
    //               price,
    //               options,
    //               stock
    //             }
    //           }
    //         }
    //       }
    //     `,
    //     variables () {
    //       return {
    //         filter: {}
    //       }
    //     },
    //     update (result) {
    //       return result.products?.products
    //     },
    //     async result (result) {
    //       this.validateAllRows()
    //     }
    //   }
    // }
  },
  computed: {
    allColours () {
      return this.$store.state.filters.colours
    },
    allRowsOk () {
      return this.validateStockToAdd?.every(r => r.allValid)
    },
    stockInput () {
      try {
        return this.csvData.map(row => {
          return {
            reference: row.Reference,
            colour: row.Colour,
            brand: row.Brand,
            qtyToAdd: Number(row.Qty)
          }
        })
      } catch (error) {
        adminNotifyError(this.$q, 'error generating input', error)
        return []
      }
    }
  },
  methods: {
    fromNow (t) {
      if (!t) return '-'
      return moment(t).fromNow()
    },
    formatDate (d) {
      if (!d) return '-'
      return moment(d).format('DD/MM/YY')
    },
    findError (row) {
      return this.addStockErrors.find(e => e.brand === row.brand && e.reference === row.reference)
    },
    clearAll () {
      this.csvData = []
      this.result = ''
    },
    // validateAllRows () {
    //   for (let row of this.csvData) {
    //     this.validateRow(row)
    //   }
    // },
    // validateRow (row) {
    //   try {
    //     row.matched_product = this.products.find(p => p.reference === row.Reference && p.attributes.brand === row.Brand.toString())
    //     row.matched_sku = (row.matched_product?.skus || []).find(sku => sku.options.colour.name === row.Colour)
    //     row.matched_colour = this.allColours.find(colour => colour.name === row.Colour) || this.colours.find(colour => colour.name === row.Colour)
    //     row.Qty = Number(row.Qty)
    //     // row.UpdatedStockPrice = Number(row.UpdatedStockPrice)
    //     // row.UpdatedContainerPrice = Number(row.UpdatedContainerPrice)
    //     if (isNaN(row.Qty)) throw Error(`Invalid Qty for sku ${row.Reference}`)
    //     // if (isNaN(row.UpdatedStockPrice)) row.UpdatedStockPrice = undefined
    //     // if (isNaN(row.UpdatedContainerPrice)) row.UpdatedContainerPrice = undefined
    //   } catch (e) {
    //     console.log(e)
    //   }
    //   // row.is_ok = row.matched_product && row.matched_colour && (row.matched_sku || row.UpdatedStockPrice || row.UpdatedContainerPrice)
    //   row.is_ok = row.matched_product && row.matched_colour && (row.matched_sku)
    // },
    async uploaderFactory (files) {
      if (!files || !files.length) return
      let csvContent = await files[0].text()
      this.csvData = await csv().fromString(csvContent)
      // this.validateAllRows()
    },
    async uploaderFactoryColours (files) {
      if (!files || !files.length) return
      let csvContent = await files[0].text()
      let colourData = await csv().fromString(csvContent)
      this.colours = []
      for (const csvrow of colourData) {
        const colour = {
          name: csvrow['Name'],
          oldDatabaseName: csvrow['Old Database Name'],
          group: csvrow['Group'],
          superGroup: csvrow['Supergroup'],
          hex: csvrow['Hex Code']
        }
        if (csvrow['RAL Name']) colour.ralName = csvrow['RAL Name']
        if (csvrow['Pantone Name']) colour.pantoneName = csvrow['Pantone Name']
        if (csvrow['Aragon Name']) colour.aragonName = csvrow['Aragon Name']
        if (csvrow['CompX Name']) colour.compxName = csvrow['CompX Name']

        this.colours.push(colour)
      }
      // this.validateAllRows()
    },
    async createSku (row) {
      try {
        if (!row.product) throw new Error('No matched product found.')
        if (!this.allColours.find(colour => colour.name === row.colour)) throw new Error('No matched colour found for row.  Manually add this colour first.')
        if (!row.UpdatedStockPrice) throw new Error('No price in row.')
        const input = {
          productId: row.matched_product.id,
          price: row.UpdatedStockPrice,
          containerPrice: row.UpdatedStockPrice,
          showInContainer: false,
          stock: row.Qty,
          barcode: '',
          attributes: [],
          options: {
            colour: JSON.stringify(row.matched_colour)
          }
        }
        await this.$apollo.mutate({
          mutation: gql`
            mutation addSku($input: SkuInput!) {
                addSku (input: $input) { id }
            }
          `,
          variables: {
            input
          }
        })
        await this.$apollo.queries.products.refetch()
      } catch (error) {
        adminNotifyError(this.$q, 'Error adding Sku!', error)
      }
      this.validateRow(row)
    },
    async addAll () {
      this.$q.dialog({
        title: 'Add All',
        message: `Are you sure you want to add these products?  This cannot be undone!`,
        cancel: true
      }).onOk(async () => {
        // TODO: Add error handling, detect errors, revert whole batch if something went wrong!?
        this.$q.loading.show({
          message: `<h4>Updating ${this.csvData.length} skus<br/>Do not close your browser...</h4>`
        })

        try {
          const result = await this.$apollo.mutate({
            mutation: gql`
            mutation addStock($input: [AddStockInput!]!) {
                addStock (input: $input) {
                    itemsAdded
                    containerPricesUpdated
                    stockPricesUpdated
                }
            }
          `,
            variables: {
              input: this.stockInput
            }
          })
          this.$q.dialog({
            title: `Done`,
            message: `Stock was updated successfully.`,
            color: 'positive'
          })
          this.result = `${result.data.addStock.itemsAdded} sets added to stock`
        } catch (error) {
          adminNotifyError(this.$q, 'Error adding stock!', error)
        }

        this.$q.loading.hide()
      })
    },
    downloadExample () {
      // const csvData = `Brand,Reference,Colour,Qty,UpdatedStockPrice,UpdatedContainerPrice
      // Kilter,K124,17-16,1,587.75`
      const csvData = `Brand,Reference,Colour,Qty
Kilter,K124,17-16,1`
      saveAs(new Blob([csvData], { type: 'application/octet-stream' }), `example_stock_to_add.csv`)
    }
  },
  data () {
    return {
      filter: '',
      csvData: [],
      errorRows: [],
      addStockErrors: [],
      pagination: {
        rowsPerPage: 20
      },
      result: '',
      colours: [],
      columns: [
        { name: 'is_ok', required: true, label: '', align: 'left', field: row => row.allValid, sortable: true },
        { name: 'brand', required: true, label: 'Brand', align: 'left', field: row => row.brand, sortable: true },
        { name: 'colour', required: true, label: 'Colour', align: 'left', field: row => row.colour, sortable: true },
        { name: 'reference', required: true, label: 'Reference', align: 'left', field: row => row.reference, sortable: true },
        { name: 'setsToAdd', required: true, label: 'Sets To Add', align: 'left', field: row => row.qtyToAdd, sortable: true },
        // { name: 'updatedStockPrice', required: true, label: 'Updated Stock Price', align: 'left', field: row => row.UpdatedStockPrice, sortable: true, format: formatCurrency },
        // { name: 'updatedContainerPrice', required: true, label: 'Updated Container Price', align: 'left', field: row => row.UpdatedContainerPrice, sortable: true, format: formatCurrency },
        { name: 'matched_product', required: true, label: 'Matched Product', align: 'center', field: row => row.product, sortable: true },
        { name: 'matched_sku', required: true, label: 'Matched Sku', align: 'center', field: row => row.sku, sortable: true },
        { name: 'matched_colour', required: true, label: 'Matched Colour', align: 'center', field: row => this.allColours.find(colour => colour.name === row.colour), sortable: true }
      ]
    }
  }
}
</script>
